import { getHostURL } from '../utils/GeneralUtil';
import { assets } from '../images/AssetPaths';

// // General
// const accountManagementEmail = 'ProXtraLoyaltyVIP@homedepot.com';
export const links = {
  faqTermsAndConditions: getHostURL('c/pro-xtra-terms-and-conditions'),
  termsAndConditionsTitle: 'Pro Xtra Terms & Conditions',
};

// Header, Badges
type tTierBadges = {
  [key: string]: any;
};
export const tierBadges: tTierBadges = {
  MEMBER: {
    icon: assets.tierBadge.MEMBER,
    label: 'MEMBER',
  },
  ELITE: {
    icon: assets.tierBadge.ELITE,
    label: 'ELITE',
  },
  VIP: {
    icon: assets.tierBadge.VIP,
    label: 'VIP',
  },
};
